import React, { useEffect, useState } from 'react';

function ProductsPage() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [categories, setCategories] = useState(['All']);

  useEffect(() => {
    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);
  }, []);

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      // Try to fetch from backend API
      const response = await fetch('/api/products/approved');
      if (response.ok) {
        const data = await response.json();
        setProducts(data.products || data);
        
        // Extract unique categories
        const uniqueCategories = ['All', ...new Set(data.products?.map(p => p.category) || [])];
        setCategories(uniqueCategories);
      } else {
        // Fallback to sample data
        loadSampleProducts();
      }
    } catch (error) {
      console.log('Using sample products...');
      loadSampleProducts();
    } finally {
      setLoading(false);
    }
  };

  const loadSampleProducts = () => {
    const sampleProducts = [
      {
        id: 1,
        name: 'Self-Help Workbook',
        price: 29.99,
        image: 'assets/images/shop/product-1.jpg',
        category: 'Books',
        rating: 4.5,
        description: 'Comprehensive self-help workbook'
      },
      {
        id: 2,
        name: 'Meditation Guide',
        price: 19.99,
        image: 'assets/images/shop/product-2.jpg',
        category: 'Digital',
        rating: 4.8,
        description: 'Step-by-step meditation guide'
      },
      {
        id: 3,
        name: 'Stress Management Kit',
        price: 49.99,
        image: 'assets/images/shop/product-3.jpg',
        category: 'Kits',
        rating: 4.6,
        description: 'Complete stress management toolkit'
      },
      {
        id: 4,
        name: 'Therapy Journal',
        price: 24.99,
        image: 'assets/images/shop/product-4.jpg',
        category: 'Books',
        rating: 4.7,
        description: 'Structured therapy journal'
      },
      {
        id: 5,
        name: 'Mindfulness App',
        price: 9.99,
        image: 'assets/images/shop/product-5.jpg',
        category: 'Digital',
        rating: 4.9,
        description: 'Mindfulness daily app access'
      },
      {
        id: 6,
        name: 'Wellness Package',
        price: 99.99,
        image: 'assets/images/shop/product-6.jpg',
        category: 'Packages',
        rating: 4.9,
        description: 'Complete wellness package'
      }
    ];
    
    setProducts(sampleProducts);
    const uniqueCategories = ['All', ...new Set(sampleProducts.map(p => p.category))];
    setCategories(uniqueCategories);
  };

  useEffect(() => {
    if (selectedCategory === 'All') {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(products.filter(p => p.category === selectedCategory));
    }
  }, [selectedCategory, products]);

  const handleAddToCart = (product) => {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    const existingProduct = cart.find(p => p.id === product.id);
    
    if (existingProduct) {
      existingProduct.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }
    
    localStorage.setItem('cart', JSON.stringify(cart));
    alert(`${product.name} added to cart!`);
  };

  return (
    <>
      {/* Page Header Start */}
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-1-2.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Our Products</h2>
            <ul className="thm-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><span>Products</span></li>
            </ul>
          </div>
        </div>
      </section>
      {/* Page Header End */}

      {/* Products Section Start */}
      <section className="products-section" style={{ padding: '80px 0' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center wow fadeInUp" style={{ marginBottom: '50px' }}>
                <span className="section-title__tagline">Shop</span>
                <h2 className="section-title__title">Our Products & Resources</h2>
              </div>
            </div>
          </div>

          {/* Category Filter */}
          <div className="row" style={{ marginBottom: '40px' }}>
            <div className="col-lg-12">
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                flexWrap: 'wrap'
              }}>
                {categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className="thm-btn"
                    style={{
                      backgroundColor: selectedCategory === category ? '#007bff' : '#f0f0f0',
                      color: selectedCategory === category ? '#fff' : '#333',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      transition: 'all 0.3s'
                    }}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>Loading products...</p>
            </div>
          ) : filteredProducts.length > 0 ? (
            <div className="row">
              {filteredProducts.map((product) => (
                <div key={product.id} className="col-lg-4 col-md-6 wow fadeInUp" style={{ marginBottom: '30px' }}>
                  <div className="product-card" style={{
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                    transition: 'transform 0.3s, box-shadow 0.3s'
                  }}>
                    <div className="product-image" style={{
                      height: '200px',
                      overflow: 'hidden',
                      position: 'relative'
                    }}>
                      <img src={product.image} alt={product.name} style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }} />
                      <div className="product-overlay" style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: 0,
                        transition: 'opacity 0.3s'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                      onMouseLeave={(e) => e.currentTarget.style.opacity = 0}>
                        <a href={`/products/${product.id}`} className="thm-btn" style={{
                          padding: '10px 20px'
                        }}>
                          View Details
                        </a>
                      </div>
                    </div>
                    <div className="product-content" style={{ padding: '20px' }}>
                      <h3 className="product-name" style={{ marginBottom: '8px', fontSize: '16px' }}>{product.name}</h3>
                      <p className="product-category" style={{
                        fontSize: '12px',
                        color: '#999',
                        marginBottom: '10px'
                      }}>
                        {product.category}
                      </p>
                      <div className="product-rating" style={{
                        marginBottom: '10px',
                        fontSize: '13px'
                      }}>
                        <span className="stars">
                          {'★'.repeat(Math.floor(product.rating))}
                          {'☆'.repeat(5 - Math.floor(product.rating))}
                        </span>
                        <span className="rating-value" style={{ marginLeft: '5px' }}>
                          {product.rating}
                        </span>
                      </div>
                      <div className="product-footer" style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderTop: '1px solid #eee',
                        paddingTop: '15px'
                      }}>
                        <p className="product-price" style={{
                          fontSize: '18px',
                          fontWeight: 'bold',
                          margin: 0,
                          color: '#007bff'
                        }}>
                          ${product.price.toFixed(2)}
                        </p>
                        <button
                          onClick={() => handleAddToCart(product)}
                          className="product-add-btn"
                          style={{
                            backgroundColor: '#007bff',
                            color: '#fff',
                            border: 'none',
                            padding: '8px 15px',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            transition: 'all 0.3s'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#0056b3';
                            e.currentTarget.style.transform = 'scale(1.05)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#007bff';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                        >
                          🛒 Add to Cart
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>No products found in this category.</p>
            </div>
          )}
        </div>
      </section>
      {/* Products Section End */}
    </>
  );
}

export default ProductsPage;
